import { useMemo } from 'react';
import { useApi } from '../infrastructure/useApi';
import { DEFAULT_API_OPTIONS } from '../infrastructure/defaults';
import { API_URLS } from '../apiUrls';
import { API_METHODS } from '../constants/apiMethods';

/**
 * Hook for accessing Shipments API methods.
 *
 * Usage:
 * const { getOrderShipmentVisibility, cancel } = useShipmentsApi();
 * await getOrderShipmentVisibility(params);
 *
 * Cancellation scope:
 * - cancel() applies to requests started by this hook instance.
 * - For independent cancellation scopes, create separate hook instances.
 */
export const useShipmentsApi = (baseOptions = DEFAULT_API_OPTIONS) => {
	const { call, cancel } = useApi(baseOptions);

	return useMemo(
		() => ({
			getOrderShipmentVisibility: ({ OrderNumber, BOLNumber }) =>
				call({
					url: API_URLS.order.getShipmentVisibility({
						OrderNumber,
						BOLNumber,
					}),
					method: API_METHODS.GET,
				}),

			cancel,
		}),
		[call, cancel]
	);
};
